(() => {
  const configElement = document.getElementById('fi-size-policy-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const known = new Map(Object.entries(config.knownVariants || {}).map(([id, allowed]) => [id, Boolean(allowed)]));
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let bypass = false;
  const allowedTitle = title => {
    const label = String(title || '').toLowerCase();
    if (/sample|discovery|decant/.test(label)) return false;
    const sizes = [...label.matchAll(/(\d+(?:[.,]\d+)?)\s*(?:ml|millilit(?:er|re)s?)\b/g)];
    if (sizes.length) return sizes.every(match => Number(match[1].replace(',', '.')) >= 20);
    const ounces = [...label.matchAll(/(\d+(?:[.,]\d+)?)\s*(?:fl\.?\s*)?(?:oz|ounces?)\b/g)];
    return ounces.every(match => Number(match[1].replace(',', '.')) * 29.5735 >= 20);
  };
  const refreshKnown = () => {
    document.querySelectorAll('[data-fi-eligible-ids]').forEach(input => {
      const ids = input.dataset.fiEligibleIds.split(',');
      ids.filter(Boolean).forEach(id => known.set(id, true));
    });
  };
  const notify = message => {
    let notice = document.getElementById('fi-size-policy-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'fi-size-policy-notice';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'position:fixed;inset:auto 16px 16px;z-index:2147483647;background:#fff;color:#111;border:1px solid #111;padding:20px;box-shadow:0 4px 24px #0003;max-width:560px;margin:auto;font:inherit;';
      const text = document.createElement('p');
      text.dataset.fiMessage = '';
      const link = document.createElement('a');
      link.href = config.cartUrl;
      link.textContent = config.viewCart;
      link.style.cssText = 'text-decoration:underline;margin-right:24px;';
      const close = document.createElement('button');
      close.type = 'button';
      close.textContent = config.close;
      close.addEventListener('click', () => notice.remove());
      notice.append(text, link, close);
      document.body.append(notice);
    }
    notice.querySelector('[data-fi-message]').textContent = message;
  };
  const checkCart = async resume => {
    if (busy) return;
    busy = true;
    try {
      const response = await fetch(`${root}cart.js`, {cache: 'no-store', headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('Cart check failed');
      const cart = await response.json();
      const blocked = cart.items.some(item => {
        const id = String(item.variant_id);
        if (known.has(id)) return !known.get(id);
        return !allowedTitle(item.variant_title === 'Default Title' || !item.variant_title ? item.product_title : item.variant_title);
      });
      if (blocked) notify(config.blocked);
      else {
        bypass = true;
        try { resume(); } finally { bypass = false; }
      }
    } catch {
      notify(config.checkFailed);
    } finally {
      busy = false;
    }
  };
  document.addEventListener('submit', event => {
    if (bypass) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href).pathname;
    if (/\/cart\/add(?:\.js)?\/?$/.test(action)) {
      const input = form.querySelector('[name="id"][data-fi-eligible-ids]');
      if (input && !input.dataset.fiEligibleIds.split(',').includes(input.value)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        notify(config.blocked);
      }
      return;
    }
    if (/\/checkout\/?$/.test(action) || event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitter = event.submitter;
      checkCart(() => form.requestSubmit(submitter || undefined));
    }
  }, true);
  document.addEventListener('click', event => {
    if (bypass) return;
    const target = event.target instanceof Element ? event.target.closest('a,button,input[type="submit"]') : null;
    if (!target) return;
    const href = target.getAttribute('href');
    const checkoutLink = href && /\/checkout(?:\/|$|\?)/.test(new URL(href, location.href).pathname);
    const checkoutButton = target.getAttribute('name') === 'checkout' || /upcart.*checkout|checkout.*upcart/i.test(target.className || '');
    if (!checkoutLink && !checkoutButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkCart(() => target.click());
  }, true);
  refreshKnown();
  document.addEventListener('variant:change', refreshKnown);
  document.addEventListener('shopify:section:load', refreshKnown);
})();
